<template>
    <div :id="containerId" class="payliance-iframe"></div>
</template>

<script>
export default {
    name: 'PaylianceForm',

    props: {
        configuration: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            iframe: null,
            tokenizedCard: null,
            instanceValidated: false,
            instanceTokenized: false,
            instanceFailed: false,
            instanceVerified: false,
        };
    },

    computed: {
        containerId() {
            return `payliance-iframe-${this._uid}`;
        },
    },

    watch: {
        configuration(val) {
            if (val) this.initIframe();
        },
    },

    mounted() {
        if (this.configuration) this.initIframe();
    },

    beforeDestroy() {
        this.iframe = null;
    },

    methods: {
        initIframe() {
            const config = { ...this.configuration, ContainerId: this.containerId };
            const scriptUrl = config.PaylianceScriptUrl;
            delete config.PaylianceScriptUrl;

            const existing = document.querySelector(`script[src="${scriptUrl}"]`);
            if (existing) existing.remove();

            const script = document.createElement('script');
            script.src = scriptUrl;
            script.async = true;
            script.onload = () => {
                this.iframe = new Payliance.PaymentCard.TokenizeIframe(config);

                this.iframe.on('validate', (data) => {
                    if (data.successful && !this.instanceValidated) {
                        this.instanceValidated = true;
                        this.iframe.submit();
                    } else if (!data.successful) {
                        this.$emit('set-loading', false);
                        this.$emit('token-error', data);
                    }
                });

                this.iframe.on('tokenize', (data) => {
                    if (data.successful && !this.instanceTokenized) {
                        this.instanceTokenized = true;
                        data.cvv = null; // purge CVV before storing
                        this.tokenizedCard = data;
                        this.iframe.verify(data.cardId, null, 'New card addition');
                    } else if (!data.successful) {
                        this.$emit('set-loading', false);
                        const errorMsg = data.message || 'Unable to tokenize card, please try again.';
                        this.$emit('token-error', { message: errorMsg });
                    }
                });

                this.iframe.on('failure', (data) => {
                    if (!this.instanceFailed) {
                        this.instanceFailed = true;
                        this.$emit('set-loading', false);
                        this.$emit('token-error', data);
                    }
                });

                this.iframe.on('verify', (data) => {
                    if (data.successful && !this.instanceVerified) {
                        this.instanceVerified = true;
                        this.$emit('verified', {
                            tokenizedCard: this.tokenizedCard,
                            verifyData: { ...data, provider: 'payliance' },
                        });
                    } else if (!data.successful) {
                        this.$emit('set-loading', false);
                        const errorMsg = data.message || 'Card verification failed, please try again.';
                        this.$emit('token-error', { message: errorMsg });
                    }
                });

                this.iframe.load();
                this.$emit('set-loading', false);
            };
            document.head.appendChild(script);
        },

        submitCard() {
            if (!this.iframe) return;
            // Reset instance flags so re-submission works
            this.instanceValidated = false;
            this.instanceTokenized = false;
            this.instanceFailed = false;
            this.instanceVerified = false;
            this.$emit('set-loading', true);
            this.iframe.validate();
        },
    },
};
</script>

<style scoped>
.payliance-iframe {
    height: 500px;
}
</style>
